import { Card } from "antd";
import { Suspense } from "react";

export default function ({ children }) {
  return <Suspense fallback={<Card loading bordered={false} />}>{children}</Suspense>;
}
